import { message } from 'antd';
import axios from 'axios';
import { FORM_ERROR } from 'final-form';

const errorCodes = {
    30: response => ({
        [FORM_ERROR]: 'Atualize a página e tente novamente.'
            + 'Houve um erro ao validar os seus dados, ou não foi possível verificar a autenticidade do reCAPTCHA.'
        ,
    }),
    101: response => {
        message.error('Credenciais inválidas');
    },
    100: response => {
        message.error('Você não tem permissão, tente novamente mais tarde.');
    },
    campanha_de_exemplo_already_exists_with: response => {
        message.info('Uma campanha com este nome já existe, por favor informe outro nome.');
    },
};

function defaultErrorMessage(response, defaultMessage) {
    const { status } = response;
    if ([412, 422].includes(status)) {
        message.error('Não foi possível concluir a operação, verifique os dados informados e tente novamente.');
        return {
            [FORM_ERROR]: 'Não foi possível concluir a operação, verifique os dados informados e tente novamente.',
        };
    }

    if (status === 403) {
        message.error('Operação não autorizada.');
        return {
            [FORM_ERROR]: 'Operação não autorizada.',
        };
    }

    if (status === 404) {
        message.error('O recurso que você solicitou não está disponível.');
        return {
            [FORM_ERROR]: 'O recurso que você solicitou não está disponível.',
        };
    }

    message.error(defaultMessage);
    return {
        [FORM_ERROR]: defaultMessage,
    };
}

const getErrorCode = response => {
    const responseData = response.data;

    if (responseData?.error?.code) return responseData.error.code;

    if (responseData?.detail) return responseData.detail.trim().toLocaleLowerCase().replace(/\s/g, '_');

    return null;
};

/**
 * Faz a extração da mensagem de erro de acordo com os vários cenários que temos
 * @param {Error} err
 */
export function extractRequestError(err, defaultMessage) {
    if (axios.isCancel(err)) {
        return {};
    }

    if (__DEV__) {
        console.warn(err);
    }

    const { response } = err;

    if (!response) {
        message.error('Você parece estar offline, verifique sua conexão com a internet.');
        return {};
    }

    const errorCode = getErrorCode(response);
    const errorFunc = errorCodes[errorCode];
    if (typeof errorFunc === 'function') {
        return errorFunc(response);
    }

    return defaultErrorMessage(response, defaultMessage);
}
